// TODO: rename this it's not clear
// NOTE: this component is used when a page doesn't have data, it displays an illustration, some copy and extra components that can be a CTA

import { ReactNode } from 'react'

interface EmptyPromptProps {
	className?: string
	illustration: any
	title: string
	description: string
	children?: ReactNode
}

const EmptyPrompt = ({
	className,
	illustration,
	title,
	description,
	children
}: EmptyPromptProps) => {
	return (
		<div className={`${className} my-20 flex flex-col`}>
			<span className="mx-auto mb-3 w-24 text-slate-400">{illustration}</span>
			<div className="mx-auto max-w-[330px] text-slate-600">
				<p className="mb-1 text-center text-2xl font-semibold">{title}</p>
				<p className="text-center text-lg font-medium">{description}</p>
			</div>
			{children}
		</div>
	)
}

export default EmptyPrompt
